export default {
	CANCELLED: 'C',
	IN_PROGRESS: 'A',
	APPROVED: 'P',
	REJECTED: 'R',
	EXCLUDED: 'E',
	HIBERNATED: 'H',
	HIBERNATING: 'I',
	LATE: 'L',
	FINALIZED: 'F',
	OPENING: 'B',
	SCHEDULED: 'D',
};
